import script from "./ProcAnexosColumn.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcAnexosColumn.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__